// extracted by mini-css-extract-plugin
export default {"title":"TVShowList_title__iOQPm","list":"TVShowList_list__oA3-Z"};